import { useQuery } from "@tanstack/react-query";
import { fetchData } from "../../utils";
import { notification } from "antd";

export const useDashboardDetails = () => {
  return useQuery({
    queryKey: ["getDashboardDetails"], // ✅ Static key
    queryFn: () => fetchData("/vendor/getdashboarddetails"), // ✅ No params
    staleTime: 5 * 60 * 1000, // optional: prevents frequent refetch
    refetchOnWindowFocus: false, // optional: stops refetch when tab is focused
    onError: () =>
      notification.error({
        key: "dashboardDetailsError",
        message: "Failed to retrieve Dashboard Details",
      }),
  });
};
